import React from 'react';
import { ShareUsingQR } from './component';
import { BOARD } from '../../../../Utils/url-builder';

export const ShareUsingQRContainer = (props) => {
  const link = BOARD.getJoinFlow();

  return <ShareUsingQR qrCode={link} />;
};
